
// State Object for LabelSettings. Dont directly mutate it anywhere except the label/mutations.js file
export const taskSettingsState = {
  taskSettingsData: {},
}


